// ExpandableText.jsx
import React, { useState } from "react";
import { Button } from "antd";

const ExpandableText = ({ text, limit = 50 }) => {
    const [expanded, setExpanded] = useState(false);

    if (!text) return "-";

    const isLong = text.length > limit;
    const displayText = expanded || !isLong ? text : `${text.slice(0, limit)}...`;

    return (
        <div>
            {displayText}
            {isLong && (
                <Button
                    type="link"
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        setExpanded(!expanded);
                    }}
                >
                    {expanded ? "Show less" : "Show more"}
                </Button>
            )}
        </div>
    );
};

export default ExpandableText;
